import FormSelect from './FormSelect'
import { CONFLICT_RESOLUTION_METHODS } from '@/constants/merges'

export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
      }),
    },
  },
  computed: {
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: Object.keys(CONFLICT_RESOLUTION_METHODS),
        ...this.config,
      }
    },
    normalizedOptions () {
      return this.mergedConfig.options
    },
    objValue () {
      return this.value ? this.value.conflictHandlingMethod : undefined
    },
  },
  methods: {
    normalizedOptionLabel (option) {
      return option ? this.decamelize(option) : ''
    },
    update (value) {
      if (value) this.$emit('input', { conflictHandlingMethod: value })
      else this.$emit('input', {})

    },
  },
}
